import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {
    CalendarModule,
    DataTableModule,
    DialogModule,
    DropdownModule,
    FileUploadModule,
    InputTextModule,
    MultiSelectModule,
    RadioButtonModule,
    SharedModule
} from 'primeng/primeng';
import {CadensSharedModule} from '../../shared';
import {CadensAdminModule} from '../../admin/admin.module';
import {CiviliteComponent} from './civilite/civilite.component';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {AdresseComponent} from './adresse/adresse.component';
import {AdresseService} from './adresse/adresse.service';
import {PreavisService} from './preavis/preavis.service';
import {ScolariteComponent} from './scolarite/scolarite.component';
import {CursusComponent} from './scolarite/cursus/cursus.component';
import {CoursComponent} from './formation/international/cours.component';
import {PiecesComponent} from './pieces/pieces.component';
import {FormationComponent} from './formation/formation.component';
import {AutresFormationsComponent} from './formation/autres-formations/autres-formations.component';
import {DiplomeComponent} from './formation/diplome/diplome.component';
import {CpesComponent} from './formation/CPES/cpes.component';
import {MasterComponent} from './formation/master/master.component';
import {InternationalComponent} from './formation/international/international.component';
import {CadensBlocksModule} from '../blocks/blocks.module';
import {ReponseService} from './formation/reponse.service';
import {FormationComponentService} from './formation/formationComponent.service';
import {CoursDisponibleService} from '../cours-disponible/cours-disponible.service';
import {CoursService} from './cours.service';
import {ConfirmDialogModule} from 'primeng/components/confirmdialog/confirmdialog';

import {
    CandidatureComponent,
    CandidatureDetailComponent,
    CandidatureFormationService,
    CandidatureResolveActionsGroupees,
    candidatureRoutes,
    CandidatureService,
    ConcoursService,
    CursusService,
    VTotauxFormationsAvisAdmissionService,
    ListeChoixService,
} from './';
import {AvisComponent} from './avis/avis.component';
import {PreavisComponent} from './preavis/preavis.component';
import {CandidaturePopupService} from './candidature-popup.service';
import {
    CandidatureTraitementDialogComponent,
    CandidatureTraitementPopupComponent
} from './candidature-traitement-dialog.component';
import {candidaturePopupRoute} from './candidature.route';
import {ConfirmationService} from 'primeng/components/common/api';
import {EnscolService} from './enscol/enscol.service';

let ENTITY_STATES = [
    ...candidatureRoutes,
    ...candidaturePopupRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensBlocksModule,
        CadensAdminModule,
        RadioButtonModule,
        FileUploadModule,
        InputTextModule,
        CalendarModule,
        DropdownModule,
        DataTableModule, SharedModule,
        MultiSelectModule,
        DialogModule,
        ConfirmDialogModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        CandidatureComponent,
        CandidatureDetailComponent,
        CiviliteComponent,
        AdresseComponent,
        PiecesComponent,
        ScolariteComponent,
        CursusComponent,
        CoursComponent,
        FormationComponent,
        AutresFormationsComponent,
        MasterComponent,
        InternationalComponent,
        DiplomeComponent,
        ConfirmationComponent,
        AvisComponent,
        PreavisComponent,
        CandidatureTraitementDialogComponent,
        CandidatureTraitementPopupComponent,
        CpesComponent
    ],
    entryComponents: [
        CandidatureComponent,
        CandidatureTraitementDialogComponent,
        CandidatureTraitementPopupComponent
    ],
    providers: [
        CandidatureService,
        CandidaturePopupService,
        CursusService,
        CoursService,
        CoursDisponibleService,
        CandidatureFormationService,
        CandidatureResolveActionsGroupees,
        ConcoursService,
        AdresseService,
        PreavisService,
        ListeChoixService,
        ReponseService,
        FormationComponentService,
        ConfirmationService,
        VTotauxFormationsAvisAdmissionService,
        EnscolService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensCandidatureModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/candidature.module.ts